module.exports = __webpack_public_path__ + "fieldata_logo.png";